<h2 *ngIf="title">
    {{title}} {{showCourseNumber ? '(' + courses.length + ')' : ''}}
</h2>
<section class="flex flex-wrap justify-center">
    <div *ngFor="let course of courses">
        <app-course-card [imageSource]="backendUrl + course.image"
            [id]="course.name"
            [name]="course.displayName"
            [difficulty]="course.difficulty"
            [price]="course.price"
            [teacherName]="course.teacher.displayName"
            [teacherImageSource]="backendUrl + course.teacher.profilePic"
            [teacherTitle]="course.teacher.title"
            [comingSoon]="course.comingSoon"
            [isPath]="course.isPath"
            [courseCount]="course.courseCount"
            [paid]="course.orders?.length > 0 && course.orders[0].status !== 'paid'">
        </app-course-card>
    </div>
</section>